/**
 * The same items in a new array, in random order (Fisher-Yates). The source of randomness is a
 * parameter rather than `Math.random` read inside: a caller shuffles once per visit with the real
 * one, and a test shuffles predictably with its own.
 */
export const shuffle = <T>(items: readonly T[], random: () => number = Math.random): T[] => {
    const shuffled = [...items];

    for (let index = shuffled.length - 1; index > 0; index--) {
        const swapWith = Math.floor(random() * (index + 1));
        [shuffled[index], shuffled[swapWith]] = [shuffled[swapWith], shuffled[index]];
    }

    return shuffled;
};
